<template>
    <canvas id="s-canvas" :width="contentWidth" :height="contentHeight"></canvas>
</template>

<script>
export default {
  props: {
    mobile: {
      type: String,
      default: ''
    }
  },
  watch: {
    mobile(val){
      this.drawPic();
    }
  },
  data(){
    return{
      contentWidth: 100,
      contentHeight: 18,
    };
  },
  created(){
    this.$nextTick( () =>{
      this.drawPic();
    });
  },
  methods: {
    drawPic () {
      let canvas = document.getElementById('s-canvas');
      let ctx = canvas.getContext('2d');
      ctx.textBaseline = 'bottom';
      // 绘制背景
      ctx.fillStyle =  '#FFFFFF';
      ctx.fillRect(0, 0, this.contentWidth, this.contentHeight);
      // 绘制文字
      for (let i = 0; i < this.mobile.length; i++) {
        this.drawText(ctx, this.mobile[i], i);
      }
    },
    drawText (ctx, txt, i) {
      ctx.fillStyle = '#323233';
      ctx.font = '14px SimHei';
      let x = (i + 1) * (this.contentWidth / (this.mobile.length + 1));
      let y = 20;
      // 修改坐标原点和旋转角度
      ctx.translate(x, y);
      ctx.fillText(txt, 0, 0);
      // 恢复坐标原点和旋转角度
      ctx.translate(-x, -y);
    },
  }

};
</script>

<style>

</style>